export default __webpack_public_path__ + "content/media/9.ac832978.jpg";